const images = require.context('@/assets/img/unit-galery', true, /\.png$/)
// 3d sprite sheets of galery icons only (not the unmatched ones in unit-galery/sprites/)
const sprites = require.context('@/assets/img/unit-galery', true, /^\.\/[a-z_]+\/[a-z0-9_]+\/sprites\/[a-z]+\.webp$/)

// unit status (getUnitsStatusesById) -> image variant; no status -> 'original'
const variantsByStatus = {
    moving: 'moving',
    idling: 'idle',
    parked: 'online',
    offline: 'offline',
    not_connection: 'offline',
}

// icon: '<category>__<name>', file: '<category>/<name>/<variant>.png'
export function getUnitGaleryIconSrc(icon, status) {
    try {
        return images(`./${icon.replace('__', '/')}/${variantsByStatus[status] || 'original'}.png`)
    } catch (e) {
        return ''
    }
}

// sprite sheet: 72 frames of 128px in 12 cols x 6 rows, frame f = heading f*5 deg (0 = nose north, clockwise)
export const SPRITE = {cell: 128, cols: 12, rows: 6, frames: 72, degPerFrame: 5}

// icon: '<category>__<name>', file: '<category>/<name>/sprites/<variant>.webp'; no sprite -> ''
export function getUnitGalerySpriteSrc(icon, status) {
    try {
        return sprites(`./${icon.replace('__', '/')}/sprites/${variantsByStatus[status] || 'original'}.webp`)
    } catch (e) {
        return ''
    }
}

export function getUnitGalerySpritePosition(course) {
    let frame = Math.round((((+course || 0) % 360) + 360) % 360 / SPRITE.degPerFrame) % SPRITE.frames
    let x = (frame % SPRITE.cols) / (SPRITE.cols - 1) * 100
    let y = Math.floor(frame / SPRITE.cols) / (SPRITE.rows - 1) * 100
    return `${+x.toFixed(4)}% ${+y.toFixed(4)}%`
}
